import { DataSourceSchema } from '@sisense/sdk-data';
import { HttpClient } from '@sisense/sdk-rest-client';
import { getHttpClient } from '@/singleton-clients';

const DATA_MODELS_API_URL_PATH = 'api/v2/datamodels';

/**
 * Returns the schema of a data source by its name.
 */
export async function getDataSourceSchema(
	dataSourceName: string,
	httpClient?: HttpClient,
): Promise<DataSourceSchema | null> {
	const client = httpClient ?? getHttpClient();
	const url = `${DATA_MODELS_API_URL_PATH}/schema?title=${encodeURIComponent(
		dataSourceName,
	)}`;
	const result = await client.get<DataSourceSchema>(url);
	return result ?? null;
}
